/* §3.1 dummy merchants. Verbatim from TRD. Backend will replace this list with an API later. */
export const DUMMY_MERCHANTS = [
  {
    id: 'm1',
    name: 'MileCollective',
    tier: 'Platinum',
    status: 'Active',
    version: 'v3',
    effFrom: '2026-05-13',
    mode: 'custom',
    ruleCount: 3,
    publishedBy: 'kshitij.magre@prozo.com',
    contractDirections: ['Forward', 'RVP-NoQC', 'RVP-QC'],
    paymentModes: ['PREPAID', 'COD'],
    gstStance: 'exclusive',
    weightCeilingKg: 10,
    invoiceCeilingInr: 50000,
    hvThresholdInr: 10000,
    pickupPincodes: ['110037', '400072', '560001'],
    brands: ['MileCollective', 'MileEssentials'],
    contactEmail: 'ops@milecollective.com',
    merchantCode: 'MERCH_001',
    arrangementType: 'ZWZ — Zone × Weight slab',
    arrangementMode: 'Blended',
    volumetricCoeff: 5000,
    rtoCharge: '50% of forward',
    rvpFormula: 'Flat ₹35 + Forward charge',
    qcFee: '₹25 per shipment',
    codStructure: 'Flat ₹27',
    codRemittance: 'T+3 working days',
    rateCardType: 'Awaiting upload',
    platinumOtpEmail: 'platinum-approvals@prozo.com',
  },
  {
    id: 'm2',
    name: 'Yuvi Collections',
    tier: 'Standard',
    status: 'Active',
    version: 'v2',
    effFrom: '2026-05-02',
    mode: 'margin',
    ruleCount: 0,
    publishedBy: 'ashwani.kumar@prozo.com',
    contractDirections: ['Forward'],
    paymentModes: ['PREPAID', 'COD'],
    gstStance: 'inclusive',
    weightCeilingKg: 5,
    invoiceCeilingInr: 30000,
    hvThresholdInr: 10000,
    pickupPincodes: ['110001'],
    brands: ['Yuvi Collections'],
    contactEmail: 'ops@yuvicollections.com',
    merchantCode: 'MERCH_002',
    arrangementType: 'ZxW — Zone × Weight',
    arrangementMode: 'Blended',
    volumetricCoeff: 5000,
    rtoCharge: '50% of forward',
    rvpFormula: 'N/A',
    qcFee: 'N/A',
    codStructure: 'Flat ₹25',
    codRemittance: 'T+5 working days',
    rateCardType: 'Blended',
    platinumOtpEmail: '',
  },
  {
    id: 'm3',
    name: 'MonkStory',
    tier: 'Platinum',
    status: 'Draft',
    version: '—',
    effFrom: null,
    mode: 'custom',
    ruleCount: 2,
    publishedBy: '—',
    contractDirections: ['Forward', 'RVP-NoQC'],
    paymentModes: ['PREPAID', 'COD'],
    gstStance: 'exclusive',
    weightCeilingKg: 20,
    invoiceCeilingInr: 100000,
    hvThresholdInr: 10000,
    pickupPincodes: ['122001', '560038'],
    brands: ['MonkStory'],
    contactEmail: 'ops@monkstory.com',
    merchantCode: 'MERCH_003',
    arrangementType: 'ZWZ — Zone × Weight slab',
    arrangementMode: 'Blended',
    volumetricCoeff: 5000,
    rtoCharge: '60% of forward',
    rvpFormula: 'Flat ₹40 + Forward charge',
    qcFee: 'N/A',
    codStructure: 'Flat ₹27 or 1% of Invoice',
    codRemittance: 'T+3 working days',
    rateCardType: 'Blended (uploaded)',
    platinumOtpEmail: 'platinum-approvals@prozo.com',
  },
  {
    id: 'm4',
    name: 'AcmeKids',
    tier: 'Standard',
    status: 'Active',
    version: 'v1',
    effFrom: '2026-04-22',
    mode: 'cheapest',
    ruleCount: 0,
    publishedBy: 'ashwani.kumar@prozo.com',
    contractDirections: ['Forward', 'RVP-NoQC'],
    paymentModes: ['PREPAID'],
    gstStance: 'exclusive',
    weightCeilingKg: 2,
    invoiceCeilingInr: 5000,
    hvThresholdInr: 10000,
    pickupPincodes: ['411001'],
    brands: ['AcmeKids'],
    contactEmail: 'ops@acmekids.com',
    merchantCode: 'MERCH_004',
    arrangementType: 'ZxW — Zone × Weight',
    arrangementMode: 'CP-wise',
    volumetricCoeff: 5000,
    rtoCharge: '70% of forward',
    rvpFormula: 'Flat ₹30 + Forward charge',
    qcFee: 'N/A',
    codStructure: 'N/A',
    codRemittance: 'N/A',
    rateCardType: 'CP-wise',
    platinumOtpEmail: '',
  },
  {
    id: 'm5',
    name: 'Beauty Beach Co.',
    tier: 'Platinum',
    status: 'Active',
    version: 'v5',
    effFrom: '2026-05-08',
    mode: 'custom',
    ruleCount: 4,
    publishedBy: 'kshitij.magre@prozo.com',
    contractDirections: ['Forward', 'RVP-NoQC', 'RVP-QC'],
    paymentModes: ['PREPAID', 'COD'],
    gstStance: 'exclusive',
    weightCeilingKg: 10,
    invoiceCeilingInr: 80000,
    hvThresholdInr: 10000,
    pickupPincodes: ['400001', '560100', '600028', '700020'],
    brands: ['Beauty Beach Co.'],
    contactEmail: 'ops@beautybeach.com',
    merchantCode: 'MERCH_005',
    arrangementType: 'ZAWA — Zone × Account × Weight × All',
    arrangementMode: 'CP-wise',
    volumetricCoeff: 5000,
    rtoCharge: '80% of forward',
    rvpFormula: 'Flat ₹45 + Forward charge',
    qcFee: '₹25 per shipment',
    codStructure: 'Flat ₹27 or 1.5% of Invoice',
    codRemittance: 'T+2 working days',
    rateCardType: 'CP-wise',
    platinumOtpEmail: 'platinum-approvals@prozo.com',
  },
];

export const DUMMY_MERCHANTS_BY_ID = Object.fromEntries(
  DUMMY_MERCHANTS.map((m) => [m.id, m]),
);
